/**
 * Normalizes email addresses so visually/semantically identical inputs (differing only by
 * case, full-width characters, or incidental whitespace) are treated as the same address by
 * every form that accepts one — invitations, registration, org member invites.
 *
 * Mirrors the backend's `EmailNormalizer` (`engine/.../service/util/text/EmailNormalizer.java`);
 * normalizing on both sides means a user never sees "already invited" surprises caused purely by
 * how they happened to type/autocapitalize their address (see #175).
 */
export function formatEmail(email: string): string {
  let result = toHalfWidth(email)
  result = result.toLowerCase()
  result = result.replace(/\s+/g, '')
  return result
}

/** Converts full-width ASCII characters (U+FF01–U+FF5E), e.g. from a JP IME, to half-width. */
export function toHalfWidth(str: string): string {
  if (!str) return str
  return str.replace(/[\uFF01-\uFF5E]/g, (char) => {
    const code = char.charCodeAt(0) - 0xff00 + 0x0020
    return String.fromCharCode(code)
  })
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** Validates against the normalized form, so full-width/whitespace variants still pass. */
export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(formatEmail(value))
}
